import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import Resource from '@/components/Resource'
import My from '@/components/My'
import integral from '@/components/integral'
import bank from '@/components/ziyuanku/bank'
import bofang from '@/components/ziyuanku/bofang'
import Mall from '@/components/Shopping/Mall'
import address from '@/components/Shopping/address'
import exchange from '@/components/Shopping/exchange'
import Courses from '@/components/wode/Courses'
import account from '@/components/wode/account'
import coupons from '@/components/wode/coupons'
import Mobile from '@/components/wode/Mobile'
import topup from '@/components/wode/topup'
import withdrawal from '@/components/wode/withdrawal'
import detail from '@/components/wode/detail'
import collection from '@/components/wode/collection'
import comments from '@/components/wode/comments'
import Place from '@/components/wode/Place'
import certification from '@/components/wode/certification'
import pingjia from '@/components/wode/pingjia'
import video from '@/components//video'
import foot from '@/components//foot'
import purchase from '@/components/ziyuanku/purchase'
import yinpin from '@/components/ziyuanku/yinpin'
import shiming from '@/components/wode/shiming'
import group from "../components/ziyuanku/group";
import purchases from "../components/ziyuanku/purchases";
import Coursess from "../components/wode/Coursess";


Vue.use(Router)



export default new Router({
  mode: 'history',  //去掉url中的#
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
    },
    {
      path: '/Resource',
      name: 'Resource',
      component: Resource
    },
    {
      path: '/My',
      name: 'My',
      component: My
    },
    {
      path: '/integral',
      name: 'integral',
      component: integral
    },
    {
      path: '/bank',
      name: 'bank',
      component: bank
    },
    {
      path: '/group',
      name: 'group',
      component: group
    },
    {
      path: '/bofang',
      name: 'bofang',
      component: bofang
    },
    {
      path: '/Mall',
      name: 'Mall',
      component: Mall
    },
    {
      path: '/exchange',
      name: 'exchange',
      component: exchange
    },
    {
      path: '/address',
      name: 'address',
      component: address
    },
    {
      path: '/Courses',
      name: 'Courses',
      component: Courses
    },{
      path: '/account',
      name: 'account',
      component: account
    },{
      path: '/coupons',
      name: 'coupons',
      component: coupons
    },{
      path: '/Mobile',
      name: 'Mobile',
      component: Mobile
    },{
      path: '/topup',
      name: 'topup',
      component: topup
    },{
      path: '/withdrawal',
      name: 'withdrawal',
      component: withdrawal
    },{
      path: '/detail',
      name: 'detail',
      component: detail
    },{
      path: '/collection',
      name: 'collection',
      component: collection
    },{
      path: '/comments',
      name: 'comments',
      component: comments
    },{
      path: '/Place',
      name: 'Place',
      component: Place
    },{
      path: '/certification',
      name: 'certification',
      component: certification
    },{
      path: '/video',
      name: 'video',
      component: video
    },{
      path: '/foot',
      name: 'foot',
      component: foot
    },{
      path: '/purchase',
      name: 'purchase',
      component: purchase
    },{
      path: '/pingjia',
      name: 'pingjia',
      component: pingjia
    },{
      path: '/shiming',
      name: 'shiming',
      component: shiming
    },{
      path: '/yinpin',
      name: 'yinpin',
      component: yinpin
    },
    {
      path: '/purchases',
      name: 'purchases',
      component: purchases
    },{
      path: '/couress',
      name: 'couress',
      component: Coursess
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js